<div class="container config-widget" [ngClass]="{'visible':languageLoaded}">
  @if (moduleAvailable('devices') && subModuleAvailable('devices','ecoTEC exclusive')) {
    <div class="row tab-row">
      <div class="container tab-container underlined">
        <div class="md-12">
          @if (subModuleAvailable('devices','ecoTEC exclusive')) {
            <div class="tab"
              [ngClass]="{'selected':cfg.isVariant('ecoTEC exclusive')}"
              (click)="getSimulatorConfig().setVariant('ecoTEC exclusive')">
              <div class="tab-content">aroTHERM plus</div>
            </div>
          }
          <!--
          <div class="tab"
            *ngIf="subModuleAvailable('devices','ecoTEC plus')"
            [ngClass]="{'selected':cfg.isVariant('ecoTEC plus')}"
            (click)="getSimulatorConfig().setVariant('ecoTEC plus')">
            <div class="tab-content">WP-AI R32</div>
          </div>
          -->
        </div>
      </div>
    </div>
  }
  <div class="row">
    @if (moduleAvailable('regelung')) {
      <div class="config-section col-xl-6 col-md-12 col-12 regelungsstrategie">
        <div class="container">
          <div class="row">
            <div class="icon col-2 col-md-3"></div>
            <div class="caption col-10 col-md-9"><span>{{ getTranslator().tr('CONFIG_UI_CAPTION_CONTROLTYPES')
            }}</span></div>
            <div class="col-12 p-3"></div>
            <div class="hidden-xs col-3"></div>
            <div class="content col-9">
              <form [formGroup]="regelungsForm">
                <!--
                <div class="form-row" *ngIf="subModuleAvailable('regelung','standalone')">
                  <div class="col-1"><input type="radio" value="standalone" formControlName="regelung"
                  [attr.disabled]='isDisabled("regelung","standalone")'></div>
                  <label class="col-4 col-md-9"
                  [ngClass]='{"disabled":isDisabled("regelung","standalone")}'>{{getTranslator().tr('CONFIG_CAPTION_STANDALONE')}}</label>
                </div>
                -->
                <!--
                <div class="form-row" *ngIf="subModuleAvailable('regelung','witterungsgefuehrt')">
                  <div class="col-1"><input type="radio" value="witterungsgefuehrt" formControlName="regelung" [attr.disabled]='isDisabled("regelung","witterungsgefuehrt")'></div>
                  <label class="col-4 col-md-9" [ngClass]='{"disabled":isDisabled("regelung","witterungsgefuehrt")}'>{{getTranslator().tr('CONFIG_UI_WEATHER_COMPENSATED')}}</label>
                </div>
                -->
                <!--
                <div class="form-row" *ngIf="subModuleAvailable('regelung','sensoDIRECT')">
                  <div class="col-1"><input type="radio" value="sensoDIRECT" formControlName="regelung" [attr.disabled]='isDisabled("regelung","sensoDIRECT")'></div>
                  <label class="col-4 col-md-9" [ngClass]='{"disabled":isDisabled("regelung","sensoDIRECT")}'>{{getTranslator().tr('CONFIG_CAPTION_SENSODIRECT')}}</label>
                </div>
                -->
                @if (subModuleAvailable('regelung','regler')) {
                  <div class="form-row">
                    <div class="col-1"><input type="radio" value="regler" formControlName="regelung"
                    [attr.disabled]='isDisabled("regelung","regler")'></div>
                    <label class="col-4 col-md-9"
                    [ngClass]='{"disabled":isDisabled("regelung","regler")}'>{{getTranslator().tr('CONFIG_CAPTION_CONTROL')}}</label>
                  </div>
                }
              </form>
            </div>
          </div>
        </div>
        <hr />
      </div>
    }

    <div class="container-fluid">
      <div class="row config-footer p-3">
        <div class="col-12">

          <form [formGroup]="languageForm">
            <div class="container-fluid">
              <div class="row">
                <div class="col-9">
                </div>
                <div class="col-3 p-1">

                </div>
                <div class="col-12 col-md-4">

                  <select class="float-left btn m-1" formControlName="language">
                    @for (lang of availableLanguages; track lang) {
                      <option [value]="lang.getCountryCode()">
                      {{lang.getLanguageNameNative()}}</option>
                    }
                  </select>

                </div>


                <div class="col-12 col-md-8 p-1">
                  <div class="flexcol floatright">
                    <div class="flexrow">
                      <button (click)="startSimulation($event)"
                        class="m-1 float-right btn btn-small btn-info bg-vaillant-green grow"
                      [attr.disabled]='isDisabled("startButton","simulation")'>{{getTranslator().tr('BUTTON_START_SIMULATION_CAPTION')}}</button>
                      <button (click)="startInstallation($event)"
                        class="m-1 float-right btn btn-small btn-info bg-vaillant-green"
                      [attr.disabled]='isDisabled("startButton","installation")'>{{getTranslator().tr('BUTTON_START_INSTALLATION_CAPTION')}}</button>
                    </div>
                    <!--
                    <div class="flexrow">
                      <button (click)="temporaryStartup($event)"
                        class="m-1 float-right btn btn-small btn-info bg-vaillant-grey grow"
                      [attr.disabled]='isDisabled("startButton","installation")'>{{getTranslator().tr('POPUP_TEXT_TEMPSTART_BUTTON')}}</button>
                    </div>
                    -->
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>


      </div>
    </div>
  </div>
</div>